module.exports = __webpack_public_path__ + "static/media/ohn1.fa900616.png";